import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import { components } from 'react-select';
import classNames from 'classnames/bind';
import { arrayOf, bool, node, oneOfType } from 'prop-types';
import { ChevronNormalDown } from "../../icons";
import { getMethodsForTestId } from "../../utils/getMethodsForTestId";
import { selectPropsPropTypes } from '../../Select/shapes';
import styles from '../SelectField.css';
var cx = classNames.bind(styles);
export var Control = function Control(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var menuIsOpen = props.menuIsOpen,
      selectProps = props.selectProps;
  var onTogglePhoneMenu = selectProps.onTogglePhoneMenu,
      value = selectProps.value,
      isDisabled = selectProps.isDisabled,
      isInputFocused = selectProps.isInputFocused,
      namespace = selectProps.namespace;

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'control'),
      getTestId = _getMethodsForTestId.getTestId;

  var icon = value === null || value === void 0 ? void 0 : value.left;
  var text = !icon && (value === null || value === void 0 ? void 0 : value.value);
  return /*#__PURE__*/React.createElement(components.Control, _extends({}, props, {
    className: cx('control', {
      control_opened: menuIsOpen,
      control_selected: value,
      control_disabled: isDisabled,
      control_input_focused: isInputFocused
    })
  }), /*#__PURE__*/React.createElement("button", _extends({}, getTestId(), {
    type: "button",
    className: cx('control__button', {
      control__button_disabled: isDisabled,
      control__button_open: menuIsOpen
    }),
    disabled: isDisabled,
    onClick: onTogglePhoneMenu,
    onFocus: onTogglePhoneMenu
  }, !isDisabled ? {
    onTouchStart: onTogglePhoneMenu
  } : {}), (icon || text) && /*#__PURE__*/React.createElement("span", _extends({
    className: cx('control__button_indicator')
  }, getTestId('icon')), icon || text), /*#__PURE__*/React.createElement("span", {
    className: cx('control__button_chevron')
  }, /*#__PURE__*/React.createElement(ChevronNormalDown, null))));
};
Control.propTypes = process.env.NODE_ENV !== "production" ? {
  children: oneOfType([arrayOf(node), node]),
  menuIsOpen: bool,
  selectProps: selectPropsPropTypes
} : {};